import { render } from "./AppFooter.vue?vue&type=template&id=4acb5283&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=4acb5283&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wesle\\Projects\\playco-cn\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acb5283"]])

export default __exports__